export const contactConfig = { whatsappNumber: '5491155081706', instagramHandle: '@agustinacanina', instagramUrl: 'https://www.instagram.com/agustinacanina/' } as const;
